// src/component/DayDropdown.js

import React from 'react';

const DayDropdown = ({ id, label, selectedValue, onChange, name, className }) => {
    const options = Array.from({ length: 31 }, (_, i) => i );

    return (
        <div>
            <select
                id={id}
                name={name} 
                className={`form-select ${className || ''}`} 
                value={selectedValue}
                onChange={onChange}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                ))}
            </select>
        </div>
    );
};

export default DayDropdown;